module.exports = __webpack_public_path__ + "c7fa1c7ce2e486c9c772d3604f1b050f.MP3";